import Marquee1 from "react-fast-marquee";
import React from 'react'

const FeatureMarquee = ({direction, style}) => {
  return (
    <section className="marquee-two">
    <div> 
<Marquee1 direction={direction} style={style} className="db-marquee marquee-left">
<div className="marquee-item">SOCIAL MEDIA </div>
<div className="marquee-item">COMMUNICATIONS </div>
<div className="marquee-item">EXPERIENCE DESIGN </div>
<div className="marquee-item">SOCIAL MEDIA MANAGEMENT </div>
<div className="marquee-item">STRATEGY </div>
<div className="marquee-item">BRANDING </div>
<div className="marquee-item">SOCIAL MEDIA MANAGEMENT </div>
<div className="marquee-item">WEB DESIGN </div>
<div className="marquee-item">ADVERTISING </div>
<div className="marquee-item">SOCIAL MEDIA </div>
<div className="marquee-item">COMMUNICATIONS </div>
<div className="marquee-item">Search Engine Optimisation (SEO) </div>
<div className="marquee-item">SOCIAL MEDIA MANAGEMENT </div>
<div className="marquee-item">Search Engine Marketing (PPC)</div>
<div className="marquee-item">Social Media Marketing Services (SMO/SMM)</div>
<div className="marquee-item">Influencer Marketing Services</div>
<div className="marquee-item">SOCIAL MEDIA MANAGEMENT </div>
<div className="marquee-item">EXPERIENCE DESIGN </div>
<div className="marquee-item">ESTABLISHED 2020 </div>
<div className="marquee-item">STRATEGY </div>
<div className="marquee-item">BRANDING </div>
<div className="marquee-item">WEB DESIGN </div>
<div className="marquee-item">ADVERTISING </div>
<div className="marquee-item">SOCIAL MEDIA </div>
</Marquee1>
</div>
</section>
  )
}

export default FeatureMarquee

